export default __webpack_public_path__ + "static/media/searchSmall.1f53e4f9.svg";